export default class Carousel {
    constructor($el) {
        this.$el = $el;
        this.$scroller = this.$el.querySelector('.js-carouselScroller');
        this.$$image = this.$el.querySelectorAll('.js-carouselImage');
        this.$$item = this.$el.querySelectorAll('.js-carouselItem');
        this.activeIndex = 0;

        if (this.$$image.length !== this.$$item.length) {
            throw new Error('Number of images and items must be equal.');
            return;
        }

        this.initListeners();
        this.setActiveIndex(0);
    }

    activateNextItem() {
        let nextIndex = this.activeIndex + 1;

        if (nextIndex == this.$$item.length) {
            nextIndex = 0;
        }

        this.setActiveIndex(nextIndex);
    }

    initListeners() {
        this.$el.addEventListener('animationend', e => {
            if (e.animationName === 'carouselItem') {
                this.activateNextItem();
            }

            const imageAnimations = [
                'carouselImageMoveInLeft',
                'carouselImageMoveInLeftImg',
                'carouselImageMoveInRight',
                'carouselImageMoveInRightImg',
                'carouselImageMoveOutLeft',
                'carouselImageMoveOutRight',
            ];

            if (imageAnimations.indexOf(e.animationName) !== -1) {
                this.$$image.forEach($image => {
                    $image.classList.remove('is-moveInLeft', 'is-moveInRight', 'is-moveOutLeft', 'is-moveOutRight');
                });
            }
        });

        this.$$item.forEach(($item, i) => {
            $item.addEventListener('click', e => {
                const direction = i < this.activeIndex ? -1 : 1;
                this.setActiveIndex(i, direction);
                this.$el.classList.add('is-interacted');
            });
        });
    }

    setActiveIndex(index, direction = 1) {
        this.$$image.forEach($image => {
            $image.style.zIndex = 0;
        });

        // Set z-index of current image to top -1
        this.$$image[this.activeIndex].style.zIndex = this.$$image.length - 1;
        this.$$image[this.activeIndex].classList.add(direction === 1 ? 'is-moveOutLeft' : 'is-moveOutRight');

        // Set z-index of new image to top
        this.$$image[index].style.zIndex = this.$$image.length;
        this.$$image[index].classList.add(direction === 1 ? 'is-moveInLeft' : 'is-moveInRight');

        this.$$item.forEach(($item, i) => {
            $item.classList.toggle('is-active', i === index);
            $item.style.zIndex = i === index ? this.$$item.length : i;
        });

        // Scroll item into view
        const itemRect = this.$$item[index].getBoundingClientRect();
        const scrollerRect = this.$scroller.getBoundingClientRect();
        const scrollLeft = this.$scroller.scrollLeft + (itemRect.left - scrollerRect.left);

        this.$scroller.scrollTo({
            behavior: 'smooth',
            left: scrollLeft,
        });

        this.activeIndex = index;
    }
}
